import { useCallback } from 'react'

import { F0Box } from '@factorialco/f0-react'
import { FormDetailDocument, UpdateFormDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { handleResult } from 'modules/core/lib/handleMutation'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import TemplateSettingsForm, { type TemplateSettingsFormValues } from './form'
import { UpdateHeader } from 'modules/layout/components/ResponsivePage/UpdateHeader'

export default function TemplateSettingsPage() {
  const { id } = useStrictParams<'id'>()

  const { data, loading } = useQuery(FormDetailDocument, {
    variables: { id, resourceType: 'Surveys::Survey' },
  })

  const [updateForm] = useMutation(UpdateFormDocument, {
    extractorFn: (mutationData) => mutationData.formsMutations.updateFormsForm,
  })

  const form = data?.forms?.form

  const defaultValues: Partial<TemplateSettingsFormValues> = {
    title: form?.title ?? '',
    description: form?.description ?? '',
    anonymous: form?.anonymous ?? false,
  }

  const handleSubmit = useCallback(
    async (values: TemplateSettingsFormValues) => {
      const result = await updateForm({
        variables: {
          id,
          title: values.title,
          description: values.description ?? '',
          anonymous: values.anonymous ?? false,
        },
      })

      const handled = handleResult(result, () => {})

      return { success: !!handled.success }
    },
    [id, updateForm]
  )

  return (
    <ResponsivePage.Body loading={loading && !form} error={undefined}>
      {form && (
        <F0Box>
          <TemplateSettingsForm defaultValues={defaultValues} onSubmit={handleSubmit} />
          <UpdateHeader title={form.title} description={form.description ?? ''} />
        </F0Box>
      )}
    </ResponsivePage.Body>
  )
}
